<template>
  <div class="soon">
    <h2>Disponível em breve!</h2>
  </div>
</template>

<script>
export default {};
</script>
